import BaseRepository          from 'Domain/Repositories/BaseRepository/BaseRepository';
import { OrganisationInvoice } from 'Domain/Models';

const config = {
  model: OrganisationInvoice,
  baseRoute: '/admin/organisation-invoice',
  singular: 'organisationInvoice',
  plural: 'organisationInvoices',
};

class OrganisationInvoiceRepository extends BaseRepository<OrganisationInvoice, typeof config.singular, typeof config.plural> {

  sendOrganisationInvoicePdf(id: number) {
    return this.makeRequest({
      path: `${this.baseRoute}/${id}/send-invoice-pdf`,
      type: 'POST',
      callback: () => true,
    });
  }

  downloadOrganisationInvoicePdf(id: number) {
    return this.makeRequest({
      path: `${this.baseRoute}/${id}/download-invoice-pdf`,
      type: 'GET',
      callback: this.downloadFile('application/pdf'),
    });
  }

}

export default new OrganisationInvoiceRepository(config);
